"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../../../../state");
var _Component = require("./Component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Container = function Container(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle;
  var _useWithdraw2fa = (0, _state.useWithdraw2fa)(),
    disableState = _useWithdraw2fa.disableState,
    disableWithdraw2fa = _useWithdraw2fa.disableWithdraw2fa;
  var _useSendWithdraw2faKe = (0, _state.useSendWithdraw2faKey)(),
    loading = _useSendWithdraw2faKe.loading,
    sendWithdraw2faKey = _useSendWithdraw2faKe.sendWithdraw2faKey,
    remainingTime = _useSendWithdraw2faKe.remainingTime;
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    isOpen: isOpen,
    toggle: toggle,
    submitLoading: disableState.loading,
    onSubmit: function onSubmit(_ref2) {
      var code = _ref2.code;
      return disableWithdraw2fa(code);
    },
    remainingTime: remainingTime,
    loading2fa: loading,
    sendKey2fa: sendWithdraw2faKey
  });
};
exports.Container = Container;